import React from 'react';

class UnderMaintenance extends React.Component {
  render() {
    return (
      <div className="login-container">
        <div className="text-center login-block under-maintenance">
          <p className="line1">ただいまメンテナンス中です</p>
          <p className="not-found">Under Maintenance</p>
          <p className="line2">申し訳ございません。ただいまメンテナンス中です。<br />
            終了までいましばらくお待ちください。</p>
        </div>
      </div>
    );
  }
}

export default UnderMaintenance;
